import classname from "classname"

import { descriptorStatusTypeMap } from "../../../utils/Enrollment.util"

import "./StatusScale.less"

const statusPercentage = {
  pending: 25,
  pending_unenroll: 75,
  in_re_enrollment: 25,
  in_progress: 50,
  active: 100,
  enrolled_elsewhere: 50,
  generic_descriptor: 50,
  banned_descriptor: 50,
  invalid_descriptor: 50,
  unenrolled: 100,
  verification_needed: 75,
  invalid_arns: 50,
  needs_assistance: 10
}

const StatusScale = ({ status }) => {
  const percentage = statusPercentage[status] || 0
  const type = descriptorStatusTypeMap[status] || "pending"
  return (
    <div className="descriptor-status-scale">
      <div
        className={classname("status-scale-filled", type)}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  )
}

export default StatusScale
